import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  title: {
    display: "flex",
    alignItems: "center",
    width: ({ isNavbarOpen }) =>
      `calc(100% - ${isNavbarOpen ? "22.5%" : "11.5%"})`,
    height: "100%",
  },
  inputWrapper: {
    marginTop: 35,
    display: "flex",
    width: "40%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    alignSelf: 'center'
  },

  appBar: {
    height: "125px",
    backgroundColor: "#11131A !important",
    zIndex: 1200,
    justifyContent: "center",
    position: "sticky",
  },
  headerWrapper: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginRight: "4%",
  },
  titleWrapper: {
    width: "63%",
    marginLeft: ({ isNavbarOpen }) => (isNavbarOpen ? 0 : "2%"),
  },
  headerTitle: {
    textAlign: "start",
    fontSize: "2.5rem",
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  breadcrumbWrapper: {
    marginBottom: "0.4rem",
  },
  navContainer: {
    position: 'absolute',
    top: '1vh',
    left: '2vw'
  },
  filterBtn: {
    textTransform: 'none',
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    color: ({ theme }) => theme.palette.mode === "light" ? '#5b5d6e' : "#fff",
    alignSelf: 'end',
    width: '7rem',
    height: '2.4rem',
    fontFamily: "Rubik !important",
    borderColor: '#E2E8F0',
    justifyContent: 'space-between',
    paddingLeft: '7px',
    fontSize: "14px",
    fontWeight: 400,
  },
  filterIcon: {
    justifyContent: 'flex-end',
    display: 'flex',
    color: ({ theme }) => theme.palette.mode === "light" ? '#5b5d6e' : "#fff",
    alignSelf: 'end'
  }
});
